import { appendQueryParamsToUrl } from "./string";

export function prepareShareObject(shareUrl, shareMessage) {
  const shareObject = {
    encodedUrl: encodeURIComponent(shareUrl),
    text: shareMessage,
    textWithUrl: "",
    encodedText: "",
    encodedTextWithUrl: "",
  };

  shareObject.textWithUrl = `${shareObject.text}\n\n${shareUrl}`;
  shareObject.encodedTextWithUrl = encodeURIComponent(shareObject.textWithUrl);

  shareObject.encodedText = encodeURIComponent(shareObject.text);

  return shareObject;
}

export function getWhatsappShareUrl({ text }) {
  let whatsappShareUrl = "";
  const baseUrl = "https://api.whatsapp.com/send";

  const params = {
    text,
  };
  whatsappShareUrl = appendQueryParamsToUrl(baseUrl, params);

  return whatsappShareUrl;
}

export function getTelegramShareUrl({ url, text }) {
  let telegramShareUrl = "";
  const baseUrl = "https://telegram.me/share/url";

  const params = {
    text,
    url,
  };

  telegramShareUrl = appendQueryParamsToUrl(baseUrl, params);

  return telegramShareUrl;
}
